import React from 'react';
import { Radio } from 'antd';

const ChartHOC = (WrappedComponent) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);
      this.state={
        selectedFilter: null
      }
    }
    componentDidMount () {
    } 

    handleSizeChange = (e) => {
      this.setState({ selectedFilter: e.target.value });
      this.props.callback(e.target.value)
    }
      
    render() {
      let filters = this.props.filters ? this.props.filters : []
      let selectedFilter = this.state.selectedFilter ? this.state.selectedFilter : filters[0]
      return (
        <div>
          {filters.length > 0 ? (<div> 
            <Radio.Group size="small" className="chartFilter" value={selectedFilter} onChange={this.handleSizeChange}>
            {filters.map(function(object, i){
                return <Radio.Button value={object} key={i}><span style={{fontSize: '12px'}}>{object}</span></Radio.Button>
            })}
            </Radio.Group>
          </div>) : <div></div>}
          <WrappedComponent {...this.props}/>
        </div>  
    );
    }
  }
    
  return HOC;
};

export default ChartHOC;